"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Sort;

var React = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/* eslint-disable */


function Sort(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(_Icon.default, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M6.238 16.584a.18.18 0 0 0 .167.167h1.583c.75 0 1.084.916.583 1.415l-2.583 2.585a.807.807 0 0 1-1.167 0l-2.583-2.585c-.5-.499-.167-1.416.583-1.416h1.583a.18.18 0 0 0 .167-.166V7.416a.18.18 0 0 0-.167-.167H2.821c-.75 0-1.083-.916-.583-1.415L4.82 3.249a.807.807 0 0 1 1.167 0L8.57 5.834c.501.499.167 1.416-.583 1.416H6.405a.18.18 0 0 0-.167.166v9.168zM11.5 8.007a1 1 0 1 1 0-2H21a1 1 0 1 1 0 2h-9.5zm6.5 3a1 1 0 1 1 0 2h-6.5a1 1 0 1 1 0-2H18zm-3 5a1 1 0 1 1 0 2h-3.5a1 1 0 1 1 0-2H15z"
  }));
}